module.exports = __webpack_public_path__ + "static/askcto-handshake.c80cff8e.svg";